import { render, staticRenderFns } from "./role-field-auth.vue?vue&type=template&id=acc7fda4&scoped=true&"
import script from "./role-field-auth.vue?vue&type=script&lang=js&"
export * from "./role-field-auth.vue?vue&type=script&lang=js&"
import style0 from "./role-field-auth.vue?vue&type=style&index=0&id=acc7fda4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc7fda4",
  null
  
)

export default component.exports